import type { IConsentConfig } from '../types/IConsentConfig';

export const essentialServicesGroup: IConsentConfig = {
  key: 'allowEssential',
  title: 'essenziell',
  description: 'Für den Betrieb der Website notwendig',
  isMandatory: true,
};
